<script>
    import { onMount } from "svelte";
    import {saveSettings, loadSettings, removeSettings} from '../lib/local-storage';
    import List, { Item, Graphic, Label } from '@smui/list';
    import Radio from '@smui/radio';

    export let onSelectBasemap = () => {}

    let settings = {};
    let selected = null;

    const updateSettings = () => {
        settings = { ...loadSettings() };

        const selectedBasemap = settings.basemaps.find(basemap => basemap.selected === true);

        if(selectedBasemap) {
            selected = selectedBasemap.id;
        }else{
            selected = settings.basemaps[0].id;
        }

    };
    
    onMount(() => {
        updateSettings();
    });
    const onSelectChange = (newValue) => {
        if(!settings.basemaps || !newValue) return;

        settings = { ...loadSettings() };
        const notSelectedBM = settings.basemaps.filter(basemap => basemap.id !== newValue);
        const selectedBM = settings.basemaps.find(basemap => basemap.id === newValue);

        notSelectedBM.map(basemap => {
            basemap.selected = false;
        });

        if(selectedBM) {
            selectedBM.selected = true;
        }

        saveSettings(settings);
        onSelectBasemap();
    };
    $: onSelectChange(selected);
</script>

<hr/>
{#if settings.basemaps}
    <List radioList>
        {#each settings.basemaps as basemap}
            <Item>
                <Graphic>
                    <Radio bind:group={selected} value={basemap.id} />
                </Graphic>
                <Label>{basemap.name}</Label>
            </Item>
        {/each}
    </List>
    <hr/>
{/if}